import { ActivityDTO } from "../dto";
import { ControlsServiceImpl } from "./serviceImpl";

export interface ControlsService {
    findActivityById(id: number): Promise<ActivityDTO>
}
export function NewControlsService(): ControlsService {
    return new ControlsServiceImpl();
}